export default function StartDate({ contract }: ContractColumnProps): JSX.Element {
  const { startDate } = contract
  return <div>{startDate}</div>
}
